<template>
    <select
      :value="currentLanguage"
      @change="handleLanguageChange"
      class="bg-white border px-3 py-2 rounded-xl  text-sm flex items-center z-[1] justify-between h-full"
    >
      <option value="nl-BE">nl</option>
      <option value="en">en</option>
      <option value="fr">fr</option>
    </select>
</template>

<script setup lang="ts">
import { useTolgee } from '@tolgee/vue';
import { computed } from 'vue';
import { useUserStore } from '@/stores/User/UserStore';
import { UserService } from '@/services/user';

const tolgee = useTolgee(['language']);
const userStore = useUserStore();

const currentLanguage = computed(() => tolgee.value.getLanguage());

const handleLanguageChange = async (event: Event) => {
  const target = event.target as HTMLSelectElement;
  const newLanguage = target.value;

  // Update Tolgee (which will update localStorage)
  await tolgee.value.changeLanguage(newLanguage);

  // If user is authenticated, persist to database
  if (userStore.getUser) {
    try {
      await UserService.updateLanguage(newLanguage);
    } catch (error) {
      console.error('Failed to update language in database:', error);
    }
  }
};
</script>
